// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCEc3tYojH94votJ0VEdvnww-f-2QSf-Vk",
  authDomain: "my-neighbor-2f144.firebaseapp.com",
  projectId: "my-neighbor-2f144",
  storageBucket: "my-neighbor-2f144.firebasestorage.app",
  messagingSenderId: "215490249660",
  appId: "1:215490249660:web:7366fcf79988ecdd5221b9",
  measurementId: "G-3VF7EMZMQ6",
};

const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Uncomment this line for local development with Firebase emulator
// connectFunctionsEmulator(functions, "localhost", 5001);
